import { render, staticRenderFns } from "./OrderHouseLandlord.vue?vue&type=template&id=0af7cf6a&scoped=true&"
import script from "./OrderHouseLandlord.vue?vue&type=script&lang=js&"
export * from "./OrderHouseLandlord.vue?vue&type=script&lang=js&"
import style0 from "./OrderHouseLandlord.vue?vue&type=style&index=0&id=0af7cf6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7cf6a",
  null
  
)

export default component.exports